module.exports = __webpack_public_path__ + "img/ico-attetion-white.c270b2c8.svg";